enum CarouselImageEnum {
  Tall,
  Wide
}

export default CarouselImageEnum;
